import React, { PureComponent } from "react";
import * as PropTypes from "prop-types";
import moment from "moment";
import { Col, Row } from "reactstrap";
import LabeledValue from "./LabeledValue";
import * as SourceInfo from "../api/SourceInfo";
import "./SignRequestInfoData.scss";
import {Popover, Position} from "@mc/react-core";
import Linkify from "../utils/parseUrl";
import SignRequestVO from "../api/gen/qsign/types/SignRequestVO";

/**
 * Meta informace o předběžném požadavku
 */

class SignPreRequestInfoData extends PureComponent {

  static propTypes = {
    signRequest: PropTypes.object.isRequired,
  };
  static defaultProps = {
  };

  formatDate = (date) => {
    return moment(date).format("D.M.YYYY");
  };

  render() {
    const { signRequest } = this.props;
    return (
        <>
      <Row noGutters className={"mt-2 sign-request-info-data"}>

        <Col xs={12} md={6} lg={3} xl={2}>
          <LabeledValue
            label="Zdroj"
            title={signRequest.sourceOrganization && signRequest.sourceOrganization}
            value={signRequest.source && SourceInfo.getCaption(signRequest.source)}
          />
        </Col>
        <Col xs={12} md={6} lg={3} xl={2}>
          <LabeledValue label="Vloženo" value={this.formatDate(signRequest.created)} />
        </Col>

      </Row>
            {signRequest.description&& <Row className={"mt-2 mb-2 pl-4 pr-4"}>
                <Col xs={10}>
                    <Popover
                        className={"custom-popover"}
                        minimal
                        content={
                            <div className={"p-2 max-popover-width"}>
                                <Linkify text={signRequest.description}/>
                            </div>
                        }
                        position={Position.BOTTOM_LEFT}
                    >
                        <Linkify linkAtStartOnly={true} text={signRequest.description} style={{cursor: "pointer"}}
                                 className={"truncate-text"}/>
                    </Popover>
                </Col>
            </Row>}
        </>
    );
  }
}

export default SignPreRequestInfoData;
